// import React, { useEffect, useState } from "react";

// const BackToTop = () => {
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     const toggleVisibility = () => {
//       setVisible(window.pageYOffset > 200);
//     };
//     window.addEventListener("scroll", toggleVisibility);
//     return () => window.removeEventListener("scroll", toggleVisibility);
//   }, []);

//   const scrollToTop = (e) => {
//     e.preventDefault();
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   return (
//     <a
//       href="#"
//       className="btn btn-lg btn-primary rounded-0 btn-lg-square back-to-top"
//       style={{ display: visible ? "inline-flex" : "none", position: "fixed", bottom: 30, right: 30, zIndex: 9999 }}
//       onClick={scrollToTop}
//       aria-label="Back to Top"
//     >
//       <i className="fa fa-angle-double-up"></i>
//     </a>
//   );
// };

// export default BackToTop;


import React, { useEffect, useState } from "react";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const container = document.querySelector(".app-scroll-container");

    const toggleVisibility = () => {
      if (container.scrollTop > 200) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    if (container) {
      container.addEventListener("scroll", toggleVisibility);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", toggleVisibility);
      }
    };
  }, []);

  const scrollToTop = (e) => {
    e.preventDefault();
    const container = document.querySelector(".app-scroll-container");
    if (container) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <a
      href="#"
      className="btn btn-lg btn-primary rounded-0 btn-lg-square back-to-top"
      style={{
        display: visible ? "inline-flex" : "none",
        position: "fixed",
        bottom: 30,
        right: 30,
        zIndex: 9999
      }}
      onClick={scrollToTop}
      aria-label="Back to Top"
    >
      <i className="fa fa-angle-double-up"></i>
    </a>
  );
};

export default BackToTop;
